"use client";
import WIP from "@/components/templates/wip";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

export default function AcademyPage() {
  const router = useRouter();
  useEffect(() => {
    router.push("/");
  }, []);
  return <WIP />;
}
